var loyaltyLionRetryCount = 0;
var maxRetries = 15;

function fixDuplicateLoyaltyLionIds() {
  if (loyaltyLionRetryCount >= maxRetries) {
    return;
  }
  
  var nodes = document.querySelectorAll('#loyaltylion');
  
  if (nodes.length > 1) {
    loyaltyLionRetryCount++;
    
    for (var i = 1; i < nodes.length; i++) {
      var node = nodes[i];
      var uniqueId = 'loyaltylion-' + i;
      node.id = uniqueId;
      
      node.classList.add('lion-isolator');
    }
  }
}

// Run the fix when the DOM is ready
document.addEventListener('DOMContentLoaded', fixDuplicateLoyaltyLionIds);

// Run the fix when Shopify's page:loaded event fires (for theme navigation)
document.addEventListener('page:loaded', fixDuplicateLoyaltyLionIds);

// Also observe for dynamic changes that might add LoyaltyLion elements
const loyaltyLionObserver = new MutationObserver(function(mutations) {
  // Check if any mutation added a #loyaltylion element
  for (var i = 0; i < mutations.length; i++) {
    var mutation = mutations[i];
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // If nodes were added, check if we need to fix IDs
      setTimeout(fixDuplicateLoyaltyLionIds, 100);
      break;
    }
  }
});

// Start observing the document body for changes
loyaltyLionObserver.observe(document.body, { 
  childList: true, 
  subtree: true 
}); 